import { useTranslation } from 'react-i18next';
import { TikTokSpecialCampaignDetail } from '@anytag/graphql';
import { RenderDataWithFallback, TableSegment } from '@anytag/shared-atoms';
import { PostReportEmpty, PostReportSegmentKeys } from '@anytag/shared-organisms';
import { TikTokCampaignReportChart } from '../TikTokCampaignReportChart';
import { TikTokCampaignReportTable } from '../TikTokCampaignReportTable';
import { useTikTokCampaignReportDetailsData } from './hooks';

export interface TikTokCampaignReportDetailsProps {
  tiktokSpecialCampaign: TikTokSpecialCampaignDetail;
}
export const TikTokCampaignReportDetails = ({ tiktokSpecialCampaign }: TikTokCampaignReportDetailsProps) => {
  const { t } = useTranslation();
  const { reportData, loading, networkStatus, segmentStatus, handleSegmentChange } = useTikTokCampaignReportDetailsData(
    { tiktokSpecialCampaign }
  );

  return (
    <RenderDataWithFallback
      hasNoData={!reportData}
      noDataNode={<PostReportEmpty />}
      loading={loading && networkStatus === 1} // Loading 1st time
    >
      {reportData ? (
        <>
          <TikTokCampaignReportChart data={reportData.chartData} />
          <TableSegment
            type="switch"
            onChange={handleSegmentChange}
            className="report-table-segment"
            values={(Object.keys(segmentStatus) as PostReportSegmentKeys[]).filter((key) => segmentStatus[key])}
            options={[
              { label: t('Total'), value: PostReportSegmentKeys.total },
              { label: t('General.Post'), value: PostReportSegmentKeys.post }
            ]}
          />
          <TikTokCampaignReportTable data={reportData} loading={loading} />
        </>
      ) : null}
    </RenderDataWithFallback>
  );
};
